import classNames from 'classnames';

// styles

// images
import ProductSchoolBanner from './images/SchoolPD.jpg';
import CategoriesSchoolBanner from './images/SchoolCategories.jpg';

import s from './SchoolBanner.sss';

type SchoolBannerProps = {
  page: 'catalog' | 'detail_page'
};

export const SchoolBanner: React.FC<SchoolBannerProps> = ({
  page,
}) => (
  <div className={classNames(s.root, { [s.catalogRoot]: page === 'catalog' })}>
    <a
      className={s.link}
      href="https://shafa.promo/school"
    >
      <img
        className={s.img}
        src={page === 'catalog' ? CategoriesSchoolBanner : ProductSchoolBanner}
        alt="School-Banner"
      />
    </a>
  </div>
);
